export default {
    edit: 'Bewerken',
    location: 'Locatie + AV',
    filter: 'Filter',
};
